import { Injectable, inject } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.authService.isLoggedIn()) {
      const rawToken = this.authService.getAuthorizationToken();
      const authToken = `Bearer ${rawToken}`;

      req = req.clone({
        setHeaders: {
          Authorization: authToken,
        },
      });
    }

    return next.handle(req);
  }
}
